'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.checkins', {
        url: '/checkins',
        templateUrl: 'app/adminCheckins/adminCheckins.html',
        controller: 'AdminCheckinsCtrl'
      });
  });